// extracted by mini-css-extract-plugin
export default {"joinWithPuplierBtn":"AboutUsJoinWithUsButton_joinWithPuplierBtn__YxEEJ","joinWithPuplierBtnText":"AboutUsJoinWithUsButton_joinWithPuplierBtnText__MMrlS"};